"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createColorScheme = void 0;
const color_1 = __importDefault(require("color"));
const defaultPalette = {
    red: "#E06C75",
    green: "#98C379",
    yellow: "#E5C07B",
    blue: "#61AFEF",
    purple: "#C678DD",
    cyan: "#56B6C2",
    orange: "#FFBB7C",
};
const getGreyScale = (base) => {
    const color = (0, color_1.default)(base);
    return {
        shade: color.darken(0.2).hex(),
        base: color.hex(),
        surface: color.lighten(0.2).hex(),
        highlight: color.lighten(0.4).hex(),
    };
};
const getColorGradient = (base, isInverted) => {
    const color = (0, color_1.default)(base);
    if (isInverted)
        return {
            bg: color.lighten(0.5).hex(),
            base: color.hex(),
            fg: color.darken(0.5).hex(),
        };
    return {
        bg: color.darken(0.5).hex(),
        base: color.hex(),
        fg: color.lighten(0.5).hex(),
    };
};
const createColorScheme = (name, base, palette = defaultPalette) => ({
    name: name,
    bg: getGreyScale(base.bg),
    fg: getGreyScale(base.fg),
    primary: getColorGradient(base.primary, (0, color_1.default)(base.bg).isLight()),
    secondary: getColorGradient(base.secondary, (0, color_1.default)(base.bg).isLight()),
    palette,
});
exports.createColorScheme = createColorScheme;
